import { DomainException } from './domain-exception';

export class DataAlreadyExistsException extends DomainException {
  constructor(message: string) {
    super(message);
  }
}
